var map = {
	"./electrolux-public/Preview": [
		839,
		8
	],
	"./job-architecture/Preview": [
		840,
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 834;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\/Preview$
// module id = 834
// module chunks = 22